const config = {
  name: 'local',
  emilyURL: 'https://leads.clear.link/api',
  lapiURL: 'https://lapi.dev.aws.clear.link',
  tcpaURL: 'https://proof.clear.link/v1',
  albertaEBillFormGUID: '9a65e223-24c4-4807-a713-924d1f6fbca8',
  businessFormGUID: 'b258672b-5de8-42f8-808f-cf58526876f5',
  contactFormGUID: '11363f49-c20a-438f-8daf-47b2c127ee61',
}

export default config
